import React from 'react';
import Products from './Products';
import './ProductsPage.css';

const ProductsPage = ({ onBack, onSelectService }) => {
  return (
    <div className="products-page">
      <div className="page-hero">
        <div className="container">
          <h1 className="page-hero-title">İSO Belgeleri</h1>
          <p className="page-hero-subtitle">
            İSO belgeleri ve kalite yönetim sistemi danışmanlık hizmetleri.
          </p>
        </div>
      </div>
      <Products showAll={true} onSelectService={onSelectService} />
    </div>
  );
};

export default ProductsPage;
